import React from 'react';
import { Fields, Wrapper } from './styled';
import { useSelector } from 'react-redux';
import { selectAgentExecutionSelected, selectAgentExecutionType } from 'store/Agents/selectors';
import { get } from 'lodash';
import ExecutionParams from 'Screens/Automation/Agents/components/AgentDetail/components/ExecutionParams';
import ExecutionDates from './components/ExecutionDates';
import NonBooleanField from 'Screens/Automation/Agents/components/AgentDetail/components/ToolParams/components/Content/components/NonBooleanField';
import BooleanField from 'Screens/Automation/Agents/components/AgentDetail/components/ExecutionParams/BooleanField';
import SelectedWorkspaces from './components/SelectedWorkspaces';
import Tags from './components/TagsSection';

const Parameters = () => {
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);
  const data = get(agentExecutionSelected, '[0]', {});
  const parameters_data = get(data, 'parameters_data', {});
  const executor_data = get(parameters_data, 'executor_data.args', {});
  const cloud_data = get(parameters_data, 'args', {});
  const agentType = useSelector(selectAgentExecutionType);
  const defaultValue = agentType === 'agent_executions' ? executor_data : cloud_data;
  const booleanParams = Object.keys(defaultValue).filter((param) => typeof defaultValue[param] === 'boolean');
  const nonBooleanParams = Object.keys(defaultValue).filter((param) => typeof defaultValue[param] !== 'boolean' && param !== 'create_date' && param !== 'update_date');

  return (
    <Wrapper>
      <ExecutionParams currentTool={ parameters_data } disabled runStatusLog />
      <ExecutionDates currentTool={ data } />
      <Fields>
        { booleanParams.map((param) => <BooleanField disabled key={ param } defaultValue={ get(defaultValue, param, false) } param={ param } parameters={ executor_data } />)}
        { nonBooleanParams.map((param) => <NonBooleanField disabled key={ param } defaultValue={ get(defaultValue, param, '') } param={ param } parameters={ executor_data } />) }
      </Fields>
      <SelectedWorkspaces data={ parameters_data } />
      <Tags data={ parameters_data } />
    </Wrapper>
  );
};

export default Parameters;
